<div id="left-info-display">
    <div class="pt-5 pl-5 top d-flex">
        <app-button class="go-home-btn" title="Back to home" icon="west" (onClick)="goBackToHome()"></app-button>
    </div>
    <div class="member-join-bg-inner pl-5">


        
        <ng-container *ngIf="stepIndex === 0">

            <a href="http://vervesuper.com.au/"><img class="member-join verv-logo"
                    src="https://vervassets.blob.core.windows.net/web/Logo1.png" loading="lazy" /></a>

            <div class="align-items-end flex-fill">
                <img src="https://vervassets.blob.core.windows.net/web/firstpage-people.webp" *ngIf="innerWidth >= 992"
                    class="member-join-people d-flex" />
            </div>

        </ng-container>

        <ng-container *ngIf="stepIndex !== 0">

            <a href="http://vervesuper.com.au/"><img class="member-join-logo verv-logo"
                    src="https://vervassets.blob.core.windows.net/web/Logo1.png" loading="lazy" /></a>

        </ng-container>

        <!-- text during nmj sign up progress -->
        <ng-container *ngIf="!completed">

            <!-- step 0 left col -->
            <ng-container *ngIf="stepIndex === 0"></ng-container>

            <!-- step 1 left col  -->
            <ng-container *ngIf="stepIndex === 1">

                <h1>About <b>you</b></h1>
                <img class="member-join-line" src="https://vervassets.blob.core.windows.net/web/nmj-line.png"
                    loading="lazy" />
                <div class="footer footer-desktop w-100" *ngIf="innerWidth >= 992">
                    <ng-template class="" [ngTemplateOutlet]="FooterStep1"></ng-template>
                </div>

            </ng-container>

            <!-- step 2 left col -->
            <ng-container *ngIf="stepIndex === 2">

                <h1 class="">Activate your account</h1>
                <h4 class="subheader">
                    This helps us verify and secure your account.
                </h4>
                <img class="member-join-line" src="https://vervassets.blob.core.windows.net/web/nmj-line.png"
                    loading="lazy" />

                <div class="footer footer-desktop w-100" *ngIf="innerWidth >= 992">
                    <ng-template class="" [ngTemplateOutlet]="FooterStep2"></ng-template>
                </div>

            </ng-container>

            <!-- step 3 left col -->
            <ng-container *ngIf="stepIndex === 3">

                <ng-container *ngIf="isManualSplit$|async">
                    <h1 class="">Choose how you split your super</h1>
                    <h4 class="subheader">Pick the options that fit. You can allocate as little as 5% to any option.
                    </h4>
                    <h6>Changed your mind? You can update your splits anytime through your online account. </h6>
                    <h6>By completing this section you are making an election for your opening balance and all future
                        contributions to your account to be allocated in the option(s) you have selected. If you’d like
                        to change investment option(s), or change where your future contributions are allocated, you can
                        do so at any time through the Member Portal.</h6>
                </ng-container>

                <ng-container *ngIf="!(isManualSplit$|async)">
                    <h1 class="">Time to choose how your super's invested</h1>
                    <h4 class="subheader">Six options, all with the same ethical values</h4>
                    <h6>Your choices today aren’t set in stone. You can change your investment options anytime in your
                        member portal.</h6>
                    <h6>Investments may be held directly, or indirectly through Exchange Traded Funds (ETFs) and other
                        managed investment vehicles AKA: your money’s still working hard, just in different ways.</h6>
                </ng-container>

                <img class="member-join-line" src="https://vervassets.blob.core.windows.net/web/nmj-line.png"
                    loading="lazy" />
                <div class="footer footer-desktop w-100" *ngIf="innerWidth >= 992">
                    <ng-template class="" [ngTemplateOutlet]="FooterStep3"></ng-template>
                </div>

            </ng-container>

            <!-- step 4 left col -->
            <ng-container *ngIf="stepIndex === 4">

                <h1 class="">Let's keep it moving</h1>
                <h4 class="subheader">Next step is to enter your Tax File number.</h4>
                <h6>Can’t find your TFN? Check your old payslips or payment summaries, log into MyGov or give the ATO a call on <a href="tel:13 28 61">13 28 61</a>.</h6>
                <img class="member-join-line" src="https://vervassets.blob.core.windows.net/web/nmj-line.png"
                    loading="lazy" />
                <div class="footer footer-desktop w-100" *ngIf="innerWidth >= 992">
                    <ng-template class="" [ngTemplateOutlet]="FooterStep4"></ng-template>
                </div>

            </ng-container>

            <!-- step 5 left col -->
            <ng-container *ngIf="stepIndex === 5">
                <h1 class="">The fine print</h1>
                <h4 class="mt-3 subheader">
                    You're almost there!
                </h4>
                <img class="member-join-line" src="https://vervassets.blob.core.windows.net/web/nmj-line.png"
                    loading="lazy" />
                <div class="footer footer-desktop w-100" *ngIf="innerWidth >= 992">
                    <ng-template class="" [ngTemplateOutlet]="FooterStep5"></ng-template>
                </div>

            </ng-container>

            <!-- step 6 left col -->
            <ng-container *ngIf="stepIndex === 6">
                <h1 class="mt-3">Let's move your super to Verve</h1>
                <h2 class="subheader">We’ll do the heavy lifting.</h2>
                <h6>
                    Simply enter your old super fund’s details and we’ll do
                    the rest.<br /><br />
                    <i>P.S. Consolidating your super into one account can
                        help to avoid multiple sets of fees.</i>
                </h6>
                <img class="member-join-line" src="https://vervassets.blob.core.windows.net/web/nmj-line.png"
                    loading="lazy" />
                <div class="footer footer-desktop w-100" *ngIf="innerWidth >= 992">
                    <ng-template class="" [ngTemplateOutlet]="FooterStep6"></ng-template>
                </div>

            </ng-container>

            <!-- step 7 left col -->
            <ng-container *ngIf="stepIndex === 7">
                <h1 class="mt-3">Is everything spot on?</h1>
                <img class="member-join-line" src="https://vervassets.blob.core.windows.net/web/nmj-line.png"
                    loading="lazy" />
                <div class="footer footer-desktop w-100" *ngIf="innerWidth >= 992">
                    <ng-template class="" [ngTemplateOutlet]="FooterStep7"></ng-template>
                </div>

            </ng-container>

        </ng-container>

        <!-- text shown for completion page -->
        <ng-container *ngIf="completed">

            <h1 class="mt-3 bold">Congratulations!</h1>
            <h3 class="subheader">You're a Verve member!</h3>
            <img class="member-join-line" src="https://vervassets.blob.core.windows.net/web/nmj-line.png"
                loading="lazy" />
            <div class="footer">
                <div class="footer footer-desktop w-100" *ngIf="innerWidth >= 992">
                    <ng-template class="" [ngTemplateOutlet]="FooterStep8"></ng-template>
                </div>
            </div>
        </ng-container>



    </div>
</div>




<ng-template #FooterStep1>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>


<ng-template #FooterStep2>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>


<ng-template #FooterStep3>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>

<ng-template #FooterStep4>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>

<ng-template #FooterStep5>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>

<ng-template #FooterStep6>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>

<ng-template #FooterStep7>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>

<ng-template #FooterStep8>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>
